import { render, staticRenderFns } from "./mainChukuManage.vue?vue&type=template&id=6523ac0a&scoped=true&"
import script from "./mainChukuManage.vue?vue&type=script&lang=js&"
export * from "./mainChukuManage.vue?vue&type=script&lang=js&"
import style0 from "./mainChukuManage.vue?vue&type=style&index=0&id=6523ac0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6523ac0a",
  null
  
)

export default component.exports